import React, {useState, useEffect, useContext} from "react";
import './index.css'

function RButton(props) {
  const {icon, text, propsClassName = '', handleClick, able = true} = props

  return (
    <button className={`r-button ${icon} ${propsClassName} ${able ? "" : "disabled"}`} onClick={handleClick}>
      <span className={`icon`}></span>
      <span className="text">{text}</span>
    </button>
  )
}

export default RButton
